module.exports = __webpack_public_path__ + "media/img/logos/2024/muttertag-bc2822c633236bb0de909e9eaea15334.svg";